var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scope-group-label"},[_c('v-chip',{attrs:{"color":_vm.color,"dark":"","label":"","small":_vm.small,"large":_vm.large}},[_vm._v(" "+_vm._s(_vm.user.group.name)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }